<template>
  <div class="room-waiting-modal-component">
    <div class="room-waiting-modal">
      <div class="room-waiting-header">
        <div class="room-waiting-title">{{ $t("waitingRoom.list.title") }}</div>
        <GrmCloseBtn @click="onClose" />
      </div>
      <div class="room-waiting-body">
        <RoomWaitingTable />
      </div>
    </div>
  </div>
</template>

<script>
import GrmCloseBtn from '@/components/Common/button/GrmCloseBtn'
import RoomWaitingTable from "@/components/Room/Waiting/Table";

export default {
  name: 'RoomWaitingModal',
  components: {
    GrmCloseBtn,
    RoomWaitingTable,
  },
  methods: {
    onClose() {
      this.$modal('RoomWaitingModal')
    }
  }
}
</script>

<style lang="scss" scoped>
.room-waiting-modal-component {
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 60px;
  z-index: 1;
}
.room-waiting-modal {
  width: 960px;
  border-radius: 6px;
  padding: 30px;
  background-color: #fff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
}
.room-waiting-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.room-waiting-title {
  font-size: 20px;
  font-weight: 700;
  color: #333;
}
.room-waiting-body {
  margin-top: 20px;
}
</style>